import React, { useState, useEffect } from 'react'
import { getStringByPropertyName, stringByPropertyNameHasValidValue } from '../../Core/Util/Helpers'
import { Above, Below } from '@jetshop/ui/Breakpoints'
import BlogMobileBanner from './Mobile/BlogMobileBanner'
import BlogDesktopBanner from './Desktop/BlogDesktopBanner'
import { htmlStringIsValid, shouldShowDescriptionContent } from '../Util/BannerHelpers'
import { BLOG_PAGE_ID, RESTORATION_SHOW_PAGE_ID } from '../Util/Constants'
import BannerSkeletonOld from '../Skeletons/BannerSkeletonOld'

const BlogBanner = ({ category, parents, categorySettings }) => {
   const [activeCategory, setActiveCategory] = useState(null)

   useEffect(() => {
      setActiveCategory(category)
   }, [setActiveCategory, category])

   const imageUrl = getStringByPropertyName(
      categorySettings?.properties,
      'image'
   )

   const description = getStringByPropertyName(
      categorySettings?.properties,
      'description'
   )

   const featuredTitle = getStringByPropertyName(
      categorySettings?.properties,
      'featuredTitle'
   )
   const htmlContent = getStringByPropertyName(
      categorySettings?.properties,
      'customContent'
   )

   const hideCategoryTags = Boolean(activeCategory?.parent?.id === BLOG_PAGE_ID || activeCategory?.parent?.id === RESTORATION_SHOW_PAGE_ID || activeCategory?.parent?.parent?.id);

   const showDescriptionContent = shouldShowDescriptionContent(description, htmlContent)

   const getDescription = (htmlContent, text) => {
      if (htmlStringIsValid(htmlContent)) {
         return (
            <div
               dangerouslySetInnerHTML={{
                  __html: htmlContent,
               }}
            />
         )
      } else if (stringByPropertyNameHasValidValue(text)) {
         return <p>{text}</p>
      }
   }

   const bannerContent = getDescription(htmlContent, description)

   if (!activeCategory) {
      return <BannerSkeletonOld></BannerSkeletonOld>
   }

   return (
      <>
         <Below breakpoint="xl">
            <BlogMobileBanner
               showDescriptionContent={showDescriptionContent}
               bannerContent={bannerContent}
               activeCategory={activeCategory}
               parents={parents}
               imageUrl={imageUrl}
               hideCategoryTags={hideCategoryTags}
            />
         </Below>
         <Above breakpoint="xl">
            <BlogDesktopBanner
               showDescriptionContent={showDescriptionContent}
               bannerContent={bannerContent}
               activeCategory={activeCategory}
               parents={parents}
               imageUrl={imageUrl}
               hideCategoryTags={hideCategoryTags}
            />
         </Above>
      </>
   )
}

export default BlogBanner
